import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { StoreLocation as StoreModel } from '../../models/store-location/store-location.model';

@Component({
  selector: 'ish-store-address',
  templateUrl: './store-address.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StoreAddressComponent {
  readonly store = input.required<StoreModel>();
}
